import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a7e6307bedae70014fc7328_1788148443200_9064a549/youngartistadmin/src/app/not-found.tsx");
